<div class="copy-button-and-popup-container">
  <div
    *ngIf="showCopyPopUp"
    class="copy-popup"
    @fadeInOut
    (@fadeInOut.done)="showCopyPopUp = false"
    [ngStyle]="popupStyle"
  >
    Copied!
  </div>
  <div
    class="copy-button-container"
    *ngIf="!withCopyIcon"
    [ngClass]="{
      'secondary-font-color': isSecondaryFontColor,
      'secondary-font-color-text': text,
    }"
    (click)="copyValue(); $event.stopPropagation()"
    matTooltip="Copy"
    matTooltipClass="tooltip-container"
  >
    <div class="text" *ngIf="text">{{ text }}</div>
  </div>
  <div
    *ngIf="withCopyIcon"
    [ngClass]="{
      'secondary-font-color': isSecondaryFontColor,
      'secondary-font-color-text': text,
    }"
    class="copy-button-container-icon"
    (click)="copyValue(); $event.stopPropagation()"
  >
    <img [ngClass]="{ 'copy-button': fixedSize }" src="assets/images/common/copy.svg" *ngIf="withCopyIcon" />
    <div class="text" *ngIf="text" matTooltip="{{ value }}">{{ text }}</div>
  </div>
</div>
